import React, { useEffect, useRef, useState } from "react";
import Navbar from ".";
import gsap from "gsap";
import { useLocation } from "react-router-dom";

const ParentNavBar = () => {
  const navbarRef = useRef(null);
  const lastScrollY = useRef(0);
  const [scrollingUp, setScrollingUp] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (scrollingUp) {
      gsap.to(navbarRef.current, {
        y: 0,
        duration: 0.5,
        ease: "power3.out",
      });
    } else {
      if (location.pathname === "/")
        navbarRef.current.style.backgroundColor = "transparent";
      gsap.to(navbarRef.current, {
        y: -160,
        duration: 0.5,
        ease: "power3.out",
      });
    }
  }, [scrollingUp]);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 10) {
        if (location.pathname === "/")
          navbarRef.current.style.backgroundColor = "transparent";
      } else {
        navbarRef.current.style.backgroundColor = "#333";
      }
      const currentScrollY = window.scrollY;
      console.log("scrolly", window.scrollY);

      if (currentScrollY > lastScrollY.current && currentScrollY > 64) {
        // Scrolling down and past the navbar height
        setScrollingUp(false);
      } else if (currentScrollY < lastScrollY.current) {
        // Scrolling up
        setScrollingUp(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000000,
        width: "100%",
        transition: "background-color 0.5s ease",
        backgroundColor: location.pathname === "/" ? "transparent" : "#333",
      }}
      ref={navbarRef}
    >
      <Navbar />
    </nav>
  );
};

export default ParentNavBar;
